import React from "react"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from '@material-ui/core/styles';

export const styles =
    makeStyles((theme) => ({
        fullInnerHeight: {
            "& p": {
                height: "100%",
                margin: "0",
            },
        },
    }));

/*This widget is solely for using the MUI Grid as a widget*/
const GridWidget = (props) => {
    const classes = styles();

    return (
        <Grid {...props} className={props.fullInnerHeight ? classes.fullInnerHeight : ""}>{props.children}</Grid>
    );
}

GridWidget.NAME = "GridWidget";
export default GridWidget
